// extracted by mini-css-extract-plugin
export var quantityInput = "_g3-0";